var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"checklist__item-type-warn"},[_vm._v("\n  "+_vm._s(_vm.warnText)+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }